import InitialState from '../initial-state';
import * as ActionName from '../action-names';
import routeUtils from '../../utils/routes/route-utils';


export default function breadcrumbsReducer(state = InitialState.getState().breadcrumbs, action) {
  switch (action.type) {

    case ActionName.UPDATE_BREADCRUMBS_FROM_ROUTE: {
      const specificPageName = routeUtils.getSpecificNameIfExists(action.details.url);
      const isSportsSpecificPage = routeUtils.isSportSpecificPage(action.details.params);

      let pageHistory = [];
      if (specificPageName) {
        pageHistory = [{ name: specificPageName, url: null, pageUrl: action.details.url }];
      } else if (isSportsSpecificPage) {
        const groupDetails = routeUtils.getGroupDetails(action.details.params, action.details.sportsList, action.details.sportGroupList);
        pageHistory = groupDetails ? groupDetails.pageHistory : [];
      }

      return Object.assign({}, state, {
        pageHistory: pageHistory,
        isBreadcrumbReady: pageHistory.length > 0
      });
    }

    case ActionName.EVENT_DETAILS_LOAD_SUCCESS: {
      const { pageHistory } = action.details;
      return Object.assign({}, state, {
        pageHistory: pageHistory,
        isBreadcrumbReady: pageHistory.length > 0
      });
    }

    case ActionName.EVENT_DETAILS_LOAD_FAILED: {
      return Object.assign({}, state, {
        pageHistory: [],
        isBreadcrumbReady: false
      });
    }
    default:
      return state;
  }
}
